<template>
<div class="p-fluid">
    <div class="p-col-12 p-lg-12">
<div class="card card-w-title">
  <div class="p-formgrid">
    <div class="group-permission-title p-grid">
      <div v-if="this.mode == 'add'">Thêm bảng giá cơ quan</div>
      <div v-else>Chỉnh sửa bảng giá cơ quan</div>
      <Toolbar class="fixed-bottom-toolbar" style="flex: auto;">
      <template slot="right">
        <Button
          label="Quay lại"
          @click="backToList()"
          class="p-button-warning"
        />
        <Button
          v-if="mode == 'edit'"
          :label="'Lưu thay đổi'"
          @click="saveData()"
          class="p-button-success"
        />
        <Button
          v-else
          :label="'Thêm mới'"
          @click="saveData()"
          class="p-button-success"
        />
      </template>
    </Toolbar>
    </div>
      <div class="card card-w-body">
        <div class="p-field p-grid" style="padding-top: 15px;">
          <div class="p-col-5 p-grid">
            <label class="p-col-4 txt-left">Mã văn phòng*</label>
            <div class="p-col-8" v-if="this.mode !== 'edit'">
              <Dropdown id="office_tpl_id" :showClear="true" :filter="true"
              v-model="office_tpl_id" :options="list_office_tpl" optionLabel="code" @change="onChangetpl($event)"
              placeholder="Chọn mã văn phòng"/>
              <small
                v-if="validationErrors && validationErrors['office_tpl_id']"
                class="p-invalid"
              >{{validationErrors['office_tpl_id']}}</small>
            </div>
            <div class="p-col-8" v-else>
              <InputText id="office_tpl_code" :disabled="this.disableEdit"
              v-model="office_tpl_code" /> 
            </div>
          </div>
          <div class="p-col-2">
          </div>
          <div class="p-col-5 p-grid">
            <label class="p-col-4 txt-left">Mã cơ quan*</label>
            <div class="p-col-8" v-if="this.mode !== 'edit'">
              <Dropdown id="office_agency_id"  :showClear="true" :filter="true" :disabled="this.disableagency"
              v-model="office_agency_id" :options="list_office_agency" optionLabel="code"
              placeholder="Chọn mã cơ quan"/>
              <small
                v-if="validationErrors && validationErrors['office_agency_id']"
                class="p-invalid"
              >{{validationErrors['office_agency_id']}}</small>
            </div>
            <div class="p-col-8" v-else>
              <InputText id="office_agency_code" :disabled="this.disableEdit"
              v-model="office_agency_code" /> 
            </div>
          </div>
        </div>
        <div class="p-field p-grid" style="padding-top: 15px;">
          <DataTable :value="organ_pricelist_detail" :filters="filters">
            
            <Column v-if="$constants.OFF_DISTRICT==0" field="name" header="Quận/ Huyện" filterMatchMode="equals"
             headerStyle="width: 15em; text-align: center" bodyStyle="width: 15em; text-align: center">
              <template #body="slotProps">
                <span>{{slotProps.data.name}}</span>
              </template>
              <template #filter>
                <Dropdown v-model="filters['name']" :filter="true" :options="listDistrict" placeholder="Chọn Quận/ Huyện" class="p-column-filter" :showClear="true">
                    <template #option="slotProps">
                        <span>{{slotProps.option}}</span>
                    </template>
                </Dropdown>
              </template>
            </Column>
            <!-- có filter ward -->
            <Column field="name_ward" header="Phường/ Xã" filterMatchMode="equals"
             headerStyle="width: 15em; text-align: center" bodyStyle="width: 15em; text-align: center">
              <template #body="slotProps">
                <span>{{slotProps.data.name_ward}}</span>
              </template>
              <template #filter> 
                <!--  -->
                <Dropdown v-model="filters['name_ward']" :filter="true" :options="listWard" placeholder="Chọn Phường/ Xã" class="p-column-filter" :showClear="true">
                    <template #option="slotProps">
                        <span>{{slotProps.option}}</span>
                    </template>
                </Dropdown>
              </template>
            </Column>
            <Column field="type1" header="Loại 1">
              <template #body="slotProps">
                <InputNumber
                  :min="-1"  v-model="slotProps.data.type1"
                  mode="currency"
                  currency="VND"
                  locale="vi-VN"
                />
              </template>
            </Column>
            <Column field="type2" header="Loại 2">
            <template #body="slotProps">
                <InputNumber
                  :min="-1"  v-model="slotProps.data.type2"
                  mode="currency"
                  currency="VND"
                  locale="vi-VN"
                />
              </template>
            </Column>
            <Column field="type3" header="Loại 3">
              <template #body="slotProps">
                <InputNumber
                  :min="-1"  v-model="slotProps.data.type3"
                  mode="currency"
                  currency="VND"
                  locale="vi-VN"
                />
              </template>
            </Column>
            <Column field="type4" header="Loại 4">
              <template #body="slotProps">
                <InputNumber
                  :min="-1"  v-model="slotProps.data.type4"
                  mode="currency"
                  currency="VND"
                  locale="vi-VN"
                />
              </template>
            </Column>
        </DataTable>
        </div>
      </div>
  </div>
</div>
    </div>
</div>
</template>

<script>
// import DataServices from '@/core/DataServices'
// import moment from "moment-timezone";
import gql from "graphql-tag";
import graphql from "@/views/admin/common/graphql";
export default {
  props: {
    mode: String,
    model: Object,
  },
  data() {
    return {
      isDistrictLoaded : false,
      validationErrors: {},
      disableagency: true,
      formMode: this.mode,
      disableEdit: false,
      office_tpl_id: null,
      list_office_tpl: [],
      office_tpl_code: '',
      list_office_agency: [],
      office_agency_code: '',
      office_agency_id: null,
      organ_pricelist_detail: [],
      organ_pricelist_detail_tmp: [],
      list_district: [],
      list_organ_pricelist: [],
      organ_pricelist_id: null,
      filters: {},
      listDistrict: [],
      listWard: [],
    }
  },
  mounted() {
    if (this.$route.params.id !== undefined) {
      this.organ_pricelist_id = this.$route.params.id
      this.disableEdit = true
    }
    if (this.mode == 'edit') {
      this.disableEdit = true
    }
    // console.log('this.group_permission_id', this.group_permission_id)
  },
  watch: {
    isDistrictLoaded(val) {
      if (val && this.$route.params.id) {
        this.$apollo.queries.organ_pricelist.start();
      }
    }
  },
  methods: {
    backToList() {
      this.$emit('back');
    },
    async onChangetpl(e) {
      console.log('e', e)
      this.list_office_agency = []
      if (e) {
        await this.getAgency(e.value);
      } else {
        this.disableagency = true
      }
    },
    async getAgency(office_tpl) {
      if (office_tpl) {
        let query = `query MyQuery($tpl_id: Int!) {
          office_agency(where: {office_agency_tpls: {tpl_id: {_eq: $tpl_id}},deleted: {_eq: false}}) {
            code
            id
          }
          organ_pricelist(where: {office_tpl_id: {_eq: $tpl_id}}) {
            office_agency_id
          }
        }`
        await this.$apollo
          .query({
            query: gql(query),
            variables: {
              tpl_id: this.office_tpl_id.id
            }
          })
          .then(async (res) => {
            console.log('res', res)
            if (res.data.office_agency.length > 0) {
              this.list_office_agency = res.data.office_agency
              this.disableagency = false
              if (res.data.organ_pricelist.length >0) {
                for (let i = 0; i < res.data.organ_pricelist.length; i++) {
                  const e = res.data.organ_pricelist[i];
                  this.list_office_agency = this.list_office_agency.filter((elem) => elem.id !== e.office_agency_id)
                }
              }
            } else {
              this.list_office_agency = []
              this.disableagency = true
            }
        })
      } else {
        this.list_office_agency = []
        this.disableagency = true
      }
    },
    async validateData() {
      this.validationErrors = {};
      var has_error = false
      if (this.mode == 'add') {
        if (!this.office_tpl_id) {
          this.validationErrors['office_tpl_id'] = 'Vui lòng chọn mã văn phòng';
          has_error = true
        }
        if (!this.office_agency_id) {
          this.validationErrors['office_agency_id'] = 'Vui lòng chọn mã cơ quan';
          has_error = true
        }
      }
      console.log('organ_pricelist_detail', this.organ_pricelist_detail)
      let error_detail = false
      for (let i = 0; i < this.organ_pricelist_detail.length; i++) {
        const e = this.organ_pricelist_detail[i];
        if (e.type1 === null || e.type2 === null || e.type3 === null || e.type4 === null) {
          error_detail = true
          // return
        }
      }
      if (error_detail == true) {
        has_error = true
        this.$toast.add({
          severity: "error",
          summary: "Thất bại",
          detail: "Vui lòng nhập đầy đủ dữ liệu giá",
          life: 2000
        });
      }
      return has_error
    },
    async analyzeData() {
      var data_organ_pricelist = {}
        data_organ_pricelist['office_tpl_id'] = this.office_tpl_id.id
        data_organ_pricelist['office_agency_id'] = this.office_agency_id.id
        var data_item= []

        for (let i = 0; i < this.organ_pricelist_detail.length; i++) {
          const item = this.organ_pricelist_detail[i]
          var data_item_item= {}
          data_item_item['district_id'] = !this.$commonFuction.isEmpty(item.district_id) ? item.district_id : null;
          data_item_item['ward_id_merger'] = !this.$commonFuction.isEmpty(item.ward_id) ? item.ward_id : null;
          data_item_item['type1'] = item.type1
          data_item_item['type2'] = item.type2
          data_item_item['type3'] = item.type3
          data_item_item['type4'] = item.type4
          data_item.push(data_item_item)
        }
        var data_organ_pricelist_item = {}
        data_organ_pricelist_item['data'] = data_item
        data_organ_pricelist['organ_pricelist_detail'] = data_organ_pricelist_item

      return data_organ_pricelist
    },
    async analyzeDataEditItem() {
      var data_item= []
      for (let i = 0; i < this.organ_pricelist_detail.length; i++) {
          const item = this.organ_pricelist_detail[i]
          var data_item_item= {}
          data_item_item['organ_pricelist_id'] = this.organ_pricelist_id
          data_item_item['district_id'] = !this.$commonFuction.isEmpty(item.district_id) ? item.district_id : null;
          data_item_item['ward_id_merger'] = !this.$commonFuction.isEmpty(item.ward_id) ? item.ward_id : null;
          data_item_item['type1'] = item.type1
          data_item_item['type2'] = item.type2
          data_item_item['type3'] = item.type3
          data_item_item['type4'] = item.type4
          data_item.push(data_item_item)
        }
      return data_item
    },
    async saveData() {
      if (await this.validateData()) {
        // console.log('true')
        return;
      }
      console.log('xxxxxxxxxxxxxxxxxxxxxxxxxxxxx')
      if (this.mode == 'add') {
        // this.$store.commit("setLoading", true);

        var data_organ_pricelist = await this.analyzeData()

        var query = `mutation MyMutation($objects: [organ_pricelist_insert_input!]!) {
            insert_organ_pricelist(objects: $objects) {
              affected_rows
              returning {
                id
              }
            }
          }`;
        console.log("query", query);
        await this.$apollo
          .mutate({
            mutation: gql(query),
            variables: {
              objects: data_organ_pricelist
            }
          })
          .then(async (res) => {
            if (res.data[Object.keys(res.data)[0]].affected_rows > 0) {
              this.$toast.add({
                severity: "success",
                summary: "Thành công",
                detail: "Lưu dữ liệu thành công",
                life: 4000
              });
              this.displayDialog = false;
              // var that = this
              setTimeout(function () {
                // that.$store.commit("setLoading", false);
                location.href = '/admin/list-organ_pricelist'
              }, 3000)
            } else {
              // this.$store.commit("setLoading", false);
              this.$toast.add({
                severity: "error",
                summary: "Thất bại",
                detail: "Lưu dữ liệu thất bại",
                life: 3000
              });
            }
          })
      } else {
        let data_organ_pricelist_item = await this.analyzeDataEditItem()
        let query = `mutation MyMutation($organ_pricelist_id: Int!, $objects: [organ_pricelist_detail_insert_input!]!) {
          delete_organ_pricelist_detail(where: {organ_pricelist_id: {_eq: $organ_pricelist_id}}) {
            affected_rows
          }
          insert_organ_pricelist_detail(objects: $objects) {
            affected_rows
          }
        }`;

        await this.$apollo
          .mutate({
            mutation: gql(query),
            variables: {
              organ_pricelist_id: this.organ_pricelist_id,
              objects: data_organ_pricelist_item,
            }
          })
          .then(async (res) => {
            if (res.data[Object.keys(res.data)[0]].affected_rows > 0) {
              this.$toast.add({
                severity: "success",
                summary: "Thành công",
                detail: "Lưu dữ liệu thành công",
                life: 4000
              });
              console.log('res',res)
              this.displayDialog = false;
              setTimeout(function () {
                // that.$store.commit("setLoading", false);
                location.href = '/admin/list-organ_pricelist'
              }, 3000)
            } else {
              // this.$store.commit("setLoading", false);
              this.$toast.add({
                severity: "error",
                summary: "Thất bại",
                detail: "Lưu dữ liệu thất bại",
                life: 3000
              });
            }
          })
      }
    },
  },
  apollo: {
    office_tpl: {
      query() {
        let query = graphql.GET_OFFICE_TPL_COMMON
        return gql(query);
      },
      update(data) {
        if(data.office_tpl){
          this.list_office_tpl = data.office_tpl
        }
      },
      fetchPolicy: "network-only",
    },
    district: {
      query() {
        //thêm where deleted = false
        let query = `
          query MyQuery {
            district(where:  {state: {type: {_eq: ${this.$constants.TYPE_STATE.URBAN}}}, deleted: {_eq: false}}, order_by: {name: asc}) {
              id
              name
            }
           ward(where:  {state_merger: {type: {_eq: ${this.$constants.TYPE_STATE.URBAN}}}, deleted: {_eq: false}}, order_by: {name: asc}) {
              id
              name
            }
          }
        `
        return gql(query);
      },
      async update(data) {
        if(data.district){
          // console.log('data',data.district)
          this.list_district = data?.district ?? []
          this.list_ward = data?.ward ?? []
          this.organ_pricelist_detail_tmp = []
          this.organ_pricelist_detail = []
          for (let j = 0; j < this.list_ward.length; j++) {
            const e = this.list_ward[j];
            this.organ_pricelist_detail_tmp.push({name:"",name_ward:e.name,type1:0,type2:0,type3:0,type4:0,district_id:null,ward_id:e.id})
            //this.listDistrict.push(e.name)
            this.listWard.push(e.name)
          } 
          for (let i = 0; i < this.list_district.length; i++) {
            const e = this.list_district[i];
            this.organ_pricelist_detail_tmp.push({name:e.name,type1:0,type2:0,type3:0,type4:0,district_id:e.id,ward_id:null})
            this.listDistrict.push(e.name)
          }
          if(this.mode == "add"){
            this.organ_pricelist_detail = this.organ_pricelist_detail_tmp
          }
          this.isDistrictLoaded = true;
          this.$forceUpdate()
        }
        console.log('listDistrict', this.listDistrict)
      },
      fetchPolicy: "network-only",
      skip() {
       // return this.mode != "add"
        return false
      }
    },
    organ_pricelist: {
      query() {
        let query = `
          query MyQuery($id: Int) {
            organ_pricelist(where: {id: {_eq: $id}}) {
              office_tpl {
                id
                code
              }
              office_agency {
                id
                code
              }
              organ_pricelist_detail(order_by: {district: {name: asc}}) {
                district {
                  id
                  name
                }
                ward_merge {
                  id
                  name
                }
                type1
                type2
                type3
                type4
              }
            }
          }
        `
        return gql(query);
      },
      variables() {
        return {
					id: this.$route.params.id
				}
      },
      update(data) {
       // console.log('data.organ_pricelist', data.organ_pricelist)
       //this.organ_pricelist_detail
        console.log('data.organ_pricelist_detail_tmp111', this.organ_pricelist_detail_tmp)
        console.log('data.ssssss', data.organ_pricelist)
        if(data.organ_pricelist) {
          if (this.organ_pricelist_detail.length < 1) {
            this.list_organ_pricelist = data.organ_pricelist
            this.office_tpl_id = this.list_organ_pricelist[0].office_tpl.id
            this.office_agency_id = this.list_organ_pricelist[0].office_agency.id
            this.office_tpl_code = this.list_organ_pricelist[0].office_tpl.code
            this.office_agency_code = this.list_organ_pricelist[0].office_agency.code
            var map_price_old = {};
            for (let i = 0; i < this.list_organ_pricelist[0].organ_pricelist_detail.length; i++) {
              const e = this.list_organ_pricelist[0].organ_pricelist_detail[i];
              console.log('e2222', e)
              var district_id_key = !this.$commonFuction.isEmpty(e.district) ? e.district.id : null;
              console.log('district_id111', district_id)
              var ward_id_key = !this.$commonFuction.isEmpty(e.ward_merge) ? e.ward_merge.id : null;
              var key_map_key = "";
              if(district_id_key){
                key_map_key = "d_" + district_id_key;
              }
              if(ward_id_key){
                key_map_key = "w_" + ward_id_key;
              }
              map_price_old[key_map_key] = {
                type1: e.type1,
                type2: e.type2,
                type3: e.type3,
                type4: e.type4
              }
              // this.organ_pricelist_detail.push({
              //   name: e.district.name,
              //   type1: e.type1,
              //   type2: e.type2,
              //   type3: e.type3,
              //   type4: e.type4,
              //   district_id: e.district.id
              // })
              // this.listDistrict.push(e.district.name)
            }
            console.log('map_price_old', map_price_old)

            this.organ_pricelist_detail = []
             for (let k = 0; k < this.organ_pricelist_detail_tmp.length; k++) {
              const item = this.organ_pricelist_detail_tmp[k];
              var district_id = !this.$commonFuction.isEmpty(item.district_id) ? item.district_id : null;
              var ward_id = !this.$commonFuction.isEmpty(item.ward_id) ? item.ward_id : null;
              var key_map = "";
              if(district_id){
                key_map = "d_" + district_id;
              }
              if(ward_id){
                key_map = "w_" + ward_id;
              }
              var old_price_item = null;
              if(!this.$commonFuction.isEmpty(map_price_old[key_map])){
                old_price_item = map_price_old[key_map];
              }
              item.type1 = old_price_item ? old_price_item.type1 : 0;
              item.type2 = old_price_item ? old_price_item.type2 : 0;
              item.type3 = old_price_item ? old_price_item.type3 : 0;
              item.type4 = old_price_item ? old_price_item.type4 : 0;
              this.organ_pricelist_detail.push(item)
              //this.listDistrict.push(e.district.name)
             }

            
          }
        }
      },
      fetchPolicy: "network-only",
      skip() {
        return !this.$route.params.id || !this.isDistrictLoaded
      }
    },
  }
}
</script>

<style lang="scss">
  .p-multiselect {
    width: 100%;
  }
  .p-multiselect-label:not(.p-placeholder) {
    padding-top: .25rem;
    padding-bottom: .25rem;
    
  }
  .category-item-value {
    padding: .25rem .5rem;
    border-radius: 3px;
    display: inline-flex;
    margin-right: .2rem;
    background-color: var(--primary-color);
    color: var(--primary-color-text);
  }
  .p-multiselect-label-container{
    height: 40px;
  }
  .card.card-w-body {
    background-color: #FAFAFA;
    // padding: 1em;
    margin-bottom: 20px;
    margin-top: 20px;
  }
  
  </style>
